import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { SlidersHorizontal } from '@liveauctioneers/hammer-ui-core/icons';
import Conversions from './components/Conversions/Conversions';
import SettingsMenu from '@liveauctioneers/caterwaul-components/lib/SettingsMenu/SettingsMenu';
import styled from 'styled-components';

type Props = {
    catalogId: number;
    onCurrencyChanged: (value) => void;
    selectedCurrency: string;
};

const LiveAuctionSettingsMenu = ({ catalogId = 0, onCurrencyChanged, selectedCurrency }: Props) => {
    return (
        <SettingsMenu
            body={
                <Wrapper>
                    <Conversions
                        catalogId={catalogId}
                        onCurrencyChanged={onCurrencyChanged}
                        selectedCurrency={selectedCurrency}
                    />
                </Wrapper>
            }
            headerText={<FormattedMessage id="bidding_console.console.settingsMenu.headerText" />}
        >
            <IconButton
                aria-label="Settings"
                icon={SlidersHorizontal}
                size="sm"
            />
        </SettingsMenu>
    );
};

export default LiveAuctionSettingsMenu;

const Wrapper = styled.div`
    min-width: 220px;
    overflow: visible;
`;
